import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-leading',
  standalone: true,
  templateUrl: '../../assets/leading.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamLeadingIcon {}
